export default __webpack_public_path__ + "static/media/apple_stimuli_es.12f697e4.mp4";